export default "__VITE_ASSET__DvYx904c__"